import React, { useState } from "react";
import { connect } from "react-redux";

import {
    Container,
    Wrapper,
    Copy,
    Bold
} from "app/NativeComponents/common";

import {
    NewHeader,
    InlineButton,
    BottomNavBar
} from "app/NativeComponents/snippets";

import { popSidePanel, submitMarketingForm } from "app/NativeActions";

const ContactSupportLeadStatuses = (props) => {
    const [loading, setLoading] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    return (
        <Container>
            <NewHeader
                title="Custom Lead Statuses"
                leftButton={{
                    icon: "arrow-back",
                    onPress: () => {
                        props.popSidePanel();
                    }
                }}
            />

            <Wrapper style={{ padding: 25 }}>
                <Copy>
                    <Bold>Custom Lead Statuses</Bold> allow you to tailor your lead
                    pipeline to match your workflow. This feature is only available on
                    higher-tier plans.
                </Copy>
                <Copy style={{ marginTop: 15 }}>
                    Please reach out to our support team if you have questions or need
                    help with enabling this feature on your account.
                </Copy>
            </Wrapper>

            <BottomNavBar>
                {submitted ? (
                    <Wrapper style={{ padding: 25 }}>
                        <Copy style={{ textAlign: "center" }}>
                            Thanks for reaching out! We'll be in touch soon!
                        </Copy>
                    </Wrapper>
                ) : (
                    <InlineButton
                        primary={true}
                        button_type="full"
                        loading={loading}
                        onPress={() => {
                            props.submitMarketingForm({
                                token: props.token,
                                type: "contact_sales",
                                onLoading: () => setLoading(true),
                                onError: () => setLoading(false),
                                onSuccess: () => {
                                    setLoading(false);
                                    setSubmitted(true);
                                }
                            });
                        }}
                    >
                        Contact Sales
                    </InlineButton>
                )}
            </BottomNavBar>
        </Container>
    );
};

const mapStateToProps = ({ auth }) => {
    const { token } = auth;
    return { token };
};

export default connect(mapStateToProps, {
    popSidePanel,
    submitMarketingForm
})(ContactSupportLeadStatuses);
